"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/inherits.js"));

var _createSuper2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createSuper.js"));

var _survey = _interopRequireDefault(require("../../client/survey"));

var CompanyList = /*#__PURE__*/function (_Survey) {
  (0, _inherits2["default"])(CompanyList, _Survey);

  var _super = (0, _createSuper2["default"])(CompanyList);

  function CompanyList(client) {
    var _this;

    (0, _classCallCheck2["default"])(this, CompanyList);
    _this = _super.call(this, client);
    _this.client = client;
    _this.resourceUrl = '/survey';
    return _this;
  }

  (0, _createClass2["default"])(CompanyList, [{
    key: "getCompanyList",
    value: function getCompanyList(data) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return this.client.post("".concat(this.resourceUrl, "/company-list"), data, args);
    }
  }, {
    key: "getEcoSystemList",
    value: function getEcoSystemList(data) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return this.client.post("".concat(this.resourceUrl, "/ecosystem-list"), data, args);
    }
  }, {
    key: "getAssessmentsData",
    value: function getAssessmentsData(companyName) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      return this.client.post("".concat(this.resourceUrl, "/company-detail"), companyName, args);
    }
  }, {
    key: "getEcoSystemAssessmentsData",
    value: function getEcoSystemAssessmentsData(ecoSystemName) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      return this.client.post("".concat(this.resourceUrl, "/ecosystem-detail"), ecoSystemName, args);
    }
  }, {
    key: "getSurveyByCompany",
    value: function getSurveyByCompany(company, params) {
      for (var _len5 = arguments.length, args = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
        args[_key5 - 2] = arguments[_key5];
      }

      return this.client.get("".concat(this.resourceUrl, "/company/").concat(company).concat(params), args);
    }
  }, {
    key: "getSurveyByEcosystem",
    value: function getSurveyByEcosystem(affiliation, params) {
      for (var _len6 = arguments.length, args = new Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
        args[_key6 - 2] = arguments[_key6];
      }

      return this.client.get("".concat(this.resourceUrl, "/ecosystem/").concat(affiliation).concat(params), args);
    }
  }, {
    key: "getSurveyByCompanyName",
    value: function getSurveyByCompanyName(companyName, search) {
      for (var _len7 = arguments.length, args = new Array(_len7 > 2 ? _len7 - 2 : 0), _key7 = 2; _key7 < _len7; _key7++) {
        args[_key7 - 2] = arguments[_key7];
      }

      return this.client.get("".concat(this.resourceUrl, "/company/").concat(companyName).concat(search), args);
    }
  }, {
    key: "getSurveyByEcoSystemName",
    value: function getSurveyByEcoSystemName(ecoSystemName, search) {
      for (var _len8 = arguments.length, args = new Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
        args[_key8 - 2] = arguments[_key8];
      }

      return this.client.get("".concat(this.resourceUrl, "/ecosystem/").concat(ecoSystemName).concat(search), args);
    }
  }, {
    key: "getSurveyResult",
    value: function getSurveyResult(surveyId) {
      for (var _len9 = arguments.length, args = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
        args[_key9 - 1] = arguments[_key9];
      }

      return this.client.get("".concat(this.resourceUrl, "/").concat(surveyId), args);
    }
  }, {
    key: "getEcoSystemCombinedAssessment",
    value: function getEcoSystemCombinedAssessment(ecoSystemName, quarter, year, surveyType) {
      for (var _len10 = arguments.length, args = new Array(_len10 > 4 ? _len10 - 4 : 0), _key10 = 4; _key10 < _len10; _key10++) {
        args[_key10 - 4] = arguments[_key10];
      }

      return this.client.get("".concat(this.resourceUrl, "/ecosystem/").concat(ecoSystemName, "?year=").concat(year, "&quarter=").concat(quarter, "&surveyType=").concat(surveyType), args);
    }
  }, {
    key: "getCompanyCombinedAssessment",
    value: function getCompanyCombinedAssessment(companyName, quarter, year, surveyType) {
      for (var _len11 = arguments.length, args = new Array(_len11 > 4 ? _len11 - 4 : 0), _key11 = 4; _key11 < _len11; _key11++) {
        args[_key11 - 4] = arguments[_key11];
      }

      return this.client.get("".concat(this.resourceUrl, "/company/").concat(companyName, "?year=").concat(year, "&quarter=").concat(quarter, "&surveyType=").concat(surveyType), args);
    }
  }, {
    key: "combinedResult",
    value: function combinedResult(data) {
      for (var _len12 = arguments.length, args = new Array(_len12 > 1 ? _len12 - 1 : 0), _key12 = 1; _key12 < _len12; _key12++) {
        args[_key12 - 1] = arguments[_key12];
      }

      return this.client.post("".concat(this.resourceUrl, "/custom-report"), data, args);
    }
  }, {
    key: "getCompanyComparisonReport",
    value: function getCompanyComparisonReport(params) {
      for (var _len13 = arguments.length, args = new Array(_len13 > 1 ? _len13 - 1 : 0), _key13 = 1; _key13 < _len13; _key13++) {
        args[_key13 - 1] = arguments[_key13];
      }

      return this.client.get("".concat(this.resourceUrl, "/organization-comparison-report").concat(params), args);
    }
  }, {
    key: "getAffiliationComparisonReport",
    value: function getAffiliationComparisonReport(params) {
      for (var _len14 = arguments.length, args = new Array(_len14 > 1 ? _len14 - 1 : 0), _key14 = 1; _key14 < _len14; _key14++) {
        args[_key14 - 1] = arguments[_key14];
      }

      return this.client.get("".concat(this.resourceUrl, "/network-comparison-report").concat(params), args);
    }
  }, {
    key: "getSurveyDateByCompany",
    value: function getSurveyDateByCompany(company, params) {
      for (var _len15 = arguments.length, args = new Array(_len15 > 2 ? _len15 - 2 : 0), _key15 = 2; _key15 < _len15; _key15++) {
        args[_key15 - 2] = arguments[_key15];
      }

      return this.client.get("".concat(this.resourceUrl, "/company/").concat(company).concat(params), args);
    }
  }, {
    key: "getSurveyDateByEcosystem",
    value: function getSurveyDateByEcosystem(affiliation, params) {
      for (var _len16 = arguments.length, args = new Array(_len16 > 2 ? _len16 - 2 : 0), _key16 = 2; _key16 < _len16; _key16++) {
        args[_key16 - 2] = arguments[_key16];
      }

      return this.client.get("".concat(this.resourceUrl, "/ecosystem/").concat(affiliation).concat(params), args);
    }
  }, {
    key: "getCategory",
    value: function getCategory(category) {
      for (var _len17 = arguments.length, args = new Array(_len17 > 1 ? _len17 - 1 : 0), _key17 = 1; _key17 < _len17; _key17++) {
        args[_key17 - 1] = arguments[_key17];
      }

      return this.client.get("".concat(this.resourceUrl, "/category/").concat(category), args);
    }
  }, {
    key: "deleteSurvey",
    value: function deleteSurvey(surveyId) {
      for (var _len18 = arguments.length, args = new Array(_len18 > 1 ? _len18 - 1 : 0), _key18 = 1; _key18 < _len18; _key18++) {
        args[_key18 - 1] = arguments[_key18];
      }

      return this.client["delete"]("/survey/".concat(surveyId), args);
    }
  }, {
    key: "createCompany",
    value: function createCompany(reqObj) {
      for (var _len19 = arguments.length, args = new Array(_len19 > 1 ? _len19 - 1 : 0), _key19 = 1; _key19 < _len19; _key19++) {
        args[_key19 - 1] = arguments[_key19];
      }

      return this.client.post("/company", reqObj, args);
    }
  }, {
    key: "getCompanyData",
    value: function getCompanyData() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      for (var _len20 = arguments.length, args = new Array(_len20 > 1 ? _len20 - 1 : 0), _key20 = 1; _key20 < _len20; _key20++) {
        args[_key20 - 1] = arguments[_key20];
      }

      return this.client.get("/companies".concat(params), args);
    }
  }, {
    key: "getMergeCompanies",
    value: function getMergeCompanies(data) {
      for (var _len21 = arguments.length, args = new Array(_len21 > 1 ? _len21 - 1 : 0), _key21 = 1; _key21 < _len21; _key21++) {
        args[_key21 - 1] = arguments[_key21];
      }

      return this.client.post("/admin/merge-companies", data, args);
    }
  }, {
    key: "updateParticipantLevel",
    value: function updateParticipantLevel(companyId, userId, data) {
      for (var _len22 = arguments.length, args = new Array(_len22 > 3 ? _len22 - 3 : 0), _key22 = 3; _key22 < _len22; _key22++) {
        args[_key22 - 3] = arguments[_key22];
      }

      return this.client.put("/company/".concat(companyId, "/member/").concat(userId, "/participant-level"), data, args);
    }
  }, {
    key: "getSOWDetails",
    value: function getSOWDetails(sowId) {
      for (var _len23 = arguments.length, args = new Array(_len23 > 1 ? _len23 - 1 : 0), _key23 = 1; _key23 < _len23; _key23++) {
        args[_key23 - 1] = arguments[_key23];
      }

      return this.client.get("/b2b-sow/".concat(sowId), args);
    }
  }, {
    key: "getCompanyMetadata",
    value: function getCompanyMetadata(companyId) {
      for (var _len24 = arguments.length, args = new Array(_len24 > 1 ? _len24 - 1 : 0), _key24 = 1; _key24 < _len24; _key24++) {
        args[_key24 - 1] = arguments[_key24];
      }

      return this.client.get("/company/".concat(companyId, "/meta-data"), args);
    }
  }, {
    key: "getOrganizationJourney",
    value: function getOrganizationJourney(orgId) {
      var _this$client;

      for (var _len25 = arguments.length, args = new Array(_len25 > 1 ? _len25 - 1 : 0), _key25 = 1; _key25 < _len25; _key25++) {
        args[_key25 - 1] = arguments[_key25];
      }

      return (_this$client = this.client).get.apply(_this$client, ["/journey?companyId=".concat(orgId)].concat(args));
    }
  }, {
    key: "updateOrganizationJourney",
    value: function updateOrganizationJourney(orgId, data) {
      var _this$client2;

      for (var _len26 = arguments.length, args = new Array(_len26 > 2 ? _len26 - 2 : 0), _key26 = 2; _key26 < _len26; _key26++) {
        args[_key26 - 2] = arguments[_key26];
      }

      return (_this$client2 = this.client).put.apply(_this$client2, ["/journey?companyId=".concat(orgId), data].concat(args));
    }
  }, {
    key: "getCompanyInviteStatus",
    value: function getCompanyInviteStatus(companyName) {
      var _this$client3;

      for (var _len27 = arguments.length, args = new Array(_len27 > 1 ? _len27 - 1 : 0), _key27 = 1; _key27 < _len27; _key27++) {
        args[_key27 - 1] = arguments[_key27];
      }

      return (_this$client3 = this.client).get.apply(_this$client3, ["/company/".concat(companyName, "/invite-only")].concat(args));
    }
  }, {
    key: "getPublicCompanyData",
    value: function getPublicCompanyData() {
      for (var _len28 = arguments.length, args = new Array(_len28), _key28 = 0; _key28 < _len28; _key28++) {
        args[_key28] = arguments[_key28];
      }

      return this.client.get('/companies/public', args);
    } // get leader assessment result for office-platform

  }, {
    key: "getLeaderAssessmentResultForOP",
    value: function getLeaderAssessmentResultForOP(userId, requestId) {
      for (var _len29 = arguments.length, args = new Array(_len29 > 2 ? _len29 - 2 : 0), _key29 = 2; _key29 < _len29; _key29++) {
        args[_key29 - 2] = arguments[_key29];
      }

      return this.client.get("".concat(this.resourceUrl, "-request/admin/leader-survey/").concat(userId, "/").concat(requestId), args);
    }
  }, {
    key: "checkDuplicateSOWName",
    value: function checkDuplicateSOWName(data) {
      var _this$client4;

      for (var _len30 = arguments.length, args = new Array(_len30 > 1 ? _len30 - 1 : 0), _key30 = 1; _key30 < _len30; _key30++) {
        args[_key30 - 1] = arguments[_key30];
      }

      return (_this$client4 = this.client).post.apply(_this$client4, ['/b2b-sow/check-duplicate', data].concat(args));
    }
  }, {
    key: "createSOW",
    value: function createSOW(data) {
      var _this$client5;

      for (var _len31 = arguments.length, args = new Array(_len31 > 1 ? _len31 - 1 : 0), _key31 = 1; _key31 < _len31; _key31++) {
        args[_key31 - 1] = arguments[_key31];
      }

      return (_this$client5 = this.client).post.apply(_this$client5, ['/b2b-sow', data].concat(args));
    }
  }, {
    key: "deactiveateSOW",
    value: function deactiveateSOW(data) {
      var _this$client6;

      for (var _len32 = arguments.length, args = new Array(_len32 > 1 ? _len32 - 1 : 0), _key32 = 1; _key32 < _len32; _key32++) {
        args[_key32 - 1] = arguments[_key32];
      }

      return (_this$client6 = this.client).post.apply(_this$client6, ['/b2b-sow/terminate', data].concat(args));
    }
  }, {
    key: "getSpecificDetailsOfSOW",
    value: function getSpecificDetailsOfSOW(data, sowId) {
      var _this$client7;

      for (var _len33 = arguments.length, args = new Array(_len33 > 2 ? _len33 - 2 : 0), _key33 = 2; _key33 < _len33; _key33++) {
        args[_key33 - 2] = arguments[_key33];
      }

      return (_this$client7 = this.client).post.apply(_this$client7, ["/b2b-sow/".concat(sowId), data].concat(args));
    }
  }, {
    key: "addCoachPaymentRates",
    value: function addCoachPaymentRates(data, coachId, sowId) {
      var _this$client8;

      for (var _len34 = arguments.length, args = new Array(_len34 > 3 ? _len34 - 3 : 0), _key34 = 3; _key34 < _len34; _key34++) {
        args[_key34 - 3] = arguments[_key34];
      }

      return (_this$client8 = this.client).post.apply(_this$client8, ["/b2b-sow/".concat(sowId, "/coach/").concat(coachId), data].concat(args));
    }
  }, {
    key: "updateCoachPaymentRates",
    value: function updateCoachPaymentRates(data, coachId, sowId) {
      var _this$client9;

      for (var _len35 = arguments.length, args = new Array(_len35 > 3 ? _len35 - 3 : 0), _key35 = 3; _key35 < _len35; _key35++) {
        args[_key35 - 3] = arguments[_key35];
      }

      return (_this$client9 = this.client).put.apply(_this$client9, ["/b2b-sow/".concat(sowId, "/coach/").concat(coachId), data].concat(args));
    }
  }, {
    key: "updateSOW",
    value: function updateSOW(data, sowId) {
      var _this$client10;

      for (var _len36 = arguments.length, args = new Array(_len36 > 2 ? _len36 - 2 : 0), _key36 = 2; _key36 < _len36; _key36++) {
        args[_key36 - 2] = arguments[_key36];
      }

      return (_this$client10 = this.client).put.apply(_this$client10, ["/b2b-sow/".concat(sowId), data].concat(args));
    }
  }, {
    key: "getSOWGroups",
    value: function getSOWGroups(sowId) {
      var _this$client11;

      for (var _len37 = arguments.length, args = new Array(_len37 > 1 ? _len37 - 1 : 0), _key37 = 1; _key37 < _len37; _key37++) {
        args[_key37 - 1] = arguments[_key37];
      }

      return (_this$client11 = this.client).get.apply(_this$client11, ["/b2b-sow/".concat(sowId, "/teams")].concat(args));
    }
  }, {
    key: "createSOWGroup",
    value: function createSOWGroup(sowId, data) {
      var _this$client12;

      for (var _len38 = arguments.length, args = new Array(_len38 > 2 ? _len38 - 2 : 0), _key38 = 2; _key38 < _len38; _key38++) {
        args[_key38 - 2] = arguments[_key38];
      }

      return (_this$client12 = this.client).post.apply(_this$client12, ["/b2b-sow/".concat(sowId, "/teams"), data].concat(args));
    }
  }, {
    key: "deactiveateSOWGroups",
    value: function deactiveateSOWGroups(data) {
      var _this$client13;

      for (var _len39 = arguments.length, args = new Array(_len39 > 1 ? _len39 - 1 : 0), _key39 = 1; _key39 < _len39; _key39++) {
        args[_key39 - 1] = arguments[_key39];
      }

      return (_this$client13 = this.client).post.apply(_this$client13, ['/b2b-sow/terminate-sow-teams', data].concat(args));
    }
  }, {
    key: "getSOWCoaches",
    value: function getSOWCoaches(sowId) {
      var _this$client14;

      for (var _len40 = arguments.length, args = new Array(_len40 > 1 ? _len40 - 1 : 0), _key40 = 1; _key40 < _len40; _key40++) {
        args[_key40 - 1] = arguments[_key40];
      }

      return (_this$client14 = this.client).get.apply(_this$client14, ["/b2b-sow/".concat(sowId, "/coaches")].concat(args));
    }
  }, {
    key: "changeGroupCoach",
    value: function changeGroupCoach(sowId, groupId, data) {
      var _this$client15;

      for (var _len41 = arguments.length, args = new Array(_len41 > 3 ? _len41 - 3 : 0), _key41 = 3; _key41 < _len41; _key41++) {
        args[_key41 - 3] = arguments[_key41];
      }

      return (_this$client15 = this.client).put.apply(_this$client15, ["/b2b-sow/".concat(sowId, "/team/").concat(groupId, "/update-coach"), data].concat(args));
    }
  }, {
    key: "updateGroupCoachpayment",
    value: function updateGroupCoachpayment(sowId, groupId, data) {
      var _this$client16;

      for (var _len42 = arguments.length, args = new Array(_len42 > 3 ? _len42 - 3 : 0), _key42 = 3; _key42 < _len42; _key42++) {
        args[_key42 - 3] = arguments[_key42];
      }

      return (_this$client16 = this.client).put.apply(_this$client16, ["/b2b-sow/".concat(sowId, "/team/").concat(groupId, "/custom-rate"), data].concat(args));
    }
  }, {
    key: "addUsersInSOW",
    value: function addUsersInSOW(sowId, data) {
      var _this$client17;

      for (var _len43 = arguments.length, args = new Array(_len43 > 2 ? _len43 - 2 : 0), _key43 = 2; _key43 < _len43; _key43++) {
        args[_key43 - 2] = arguments[_key43];
      }

      return (_this$client17 = this.client).post.apply(_this$client17, ["/b2b-sow/".concat(sowId, "/add-users"), data].concat(args));
    }
  }, {
    key: "addUsersInGroup",
    value: function addUsersInGroup(groupId, data) {
      var _this$client18;

      for (var _len44 = arguments.length, args = new Array(_len44 > 2 ? _len44 - 2 : 0), _key44 = 2; _key44 < _len44; _key44++) {
        args[_key44 - 2] = arguments[_key44];
      }

      return (_this$client18 = this.client).post.apply(_this$client18, ["/b2b-sow/team/".concat(groupId, "/add-members"), data].concat(args));
    }
  }, {
    key: "getGroupCoachInfo",
    value: function getGroupCoachInfo(groupId, data) {
      var url = "/b2b-sow/team/".concat(groupId, "/coaches-and-rate");

      for (var _len45 = arguments.length, args = new Array(_len45 > 2 ? _len45 - 2 : 0), _key45 = 2; _key45 < _len45; _key45++) {
        args[_key45 - 2] = arguments[_key45];
      }

      if (data) {
        var _this$client19;

        return (_this$client19 = this.client).post.apply(_this$client19, [url, data].concat(args));
      } else {
        var _this$client20;

        return (_this$client20 = this.client).post.apply(_this$client20, [url].concat(args));
      }
    }
  }, {
    key: "removeUsersFromGroup",
    value: function removeUsersFromGroup(groupId, data) {
      var _this$client21;

      for (var _len46 = arguments.length, args = new Array(_len46 > 2 ? _len46 - 2 : 0), _key46 = 2; _key46 < _len46; _key46++) {
        args[_key46 - 2] = arguments[_key46];
      }

      return (_this$client21 = this.client).post.apply(_this$client21, ["/b2b-sow/team/".concat(groupId, "/remove-members"), data].concat(args));
    }
  }, {
    key: "removeUsersFromSOW",
    value: function removeUsersFromSOW(sowId, data) {
      var _this$client22;

      for (var _len47 = arguments.length, args = new Array(_len47 > 2 ? _len47 - 2 : 0), _key47 = 2; _key47 < _len47; _key47++) {
        args[_key47 - 2] = arguments[_key47];
      }

      return (_this$client22 = this.client).post.apply(_this$client22, ["/b2b-sow/".concat(sowId, "/remove-users"), data].concat(args));
    }
  }, {
    key: "assignCoachToSOWUsers",
    value: function assignCoachToSOWUsers(sowId, coachId, data) {
      var _this$client23;

      for (var _len48 = arguments.length, args = new Array(_len48 > 3 ? _len48 - 3 : 0), _key48 = 3; _key48 < _len48; _key48++) {
        args[_key48 - 3] = arguments[_key48];
      }

      return (_this$client23 = this.client).post.apply(_this$client23, ["/b2b-sow/".concat(sowId, "/coach/").concat(coachId, "/users"), data].concat(args));
    }
  }, {
    key: "getRemoveCoachesMapping",
    value: function getRemoveCoachesMapping(sowId, data) {
      var _this$client24;

      for (var _len49 = arguments.length, args = new Array(_len49 > 2 ? _len49 - 2 : 0), _key49 = 2; _key49 < _len49; _key49++) {
        args[_key49 - 2] = arguments[_key49];
      }

      return (_this$client24 = this.client).post.apply(_this$client24, ["/b2b-sow/".concat(sowId, "/remove-coaches-mapping"), data].concat(args));
    }
  }, {
    key: "removeCoachesFromSOW",
    value: function removeCoachesFromSOW(sowId, data) {
      var _this$client25;

      for (var _len50 = arguments.length, args = new Array(_len50 > 2 ? _len50 - 2 : 0), _key50 = 2; _key50 < _len50; _key50++) {
        args[_key50 - 2] = arguments[_key50];
      }

      return (_this$client25 = this.client).post.apply(_this$client25, ["/b2b-sow/".concat(sowId, "/remove-coaches"), data].concat(args));
    }
  }, {
    key: "removeCoachesFromGroup",
    value: function removeCoachesFromGroup(sowGroupId, data) {
      var _this$client26;

      for (var _len51 = arguments.length, args = new Array(_len51 > 2 ? _len51 - 2 : 0), _key51 = 2; _key51 < _len51; _key51++) {
        args[_key51 - 2] = arguments[_key51];
      }

      return (_this$client26 = this.client).post.apply(_this$client26, ["/b2b-sow/team/".concat(sowGroupId, "/remove-coaches"), data].concat(args));
    }
  }, {
    key: "getSOWGroupCoaches",
    value: function getSOWGroupCoaches(sowGroupId, reqData) {
      var _this$client27;

      for (var _len52 = arguments.length, args = new Array(_len52 > 2 ? _len52 - 2 : 0), _key52 = 2; _key52 < _len52; _key52++) {
        args[_key52 - 2] = arguments[_key52];
      }

      return (_this$client27 = this.client).post.apply(_this$client27, ["/b2b-sow/team/".concat(sowGroupId, "/coaches"), reqData].concat(args));
    }
  }, {
    key: "getExcludedSOWGroupCoaches",
    value: function getExcludedSOWGroupCoaches(sowGroupId, reqData) {
      var _this$client28;

      for (var _len53 = arguments.length, args = new Array(_len53 > 2 ? _len53 - 2 : 0), _key53 = 2; _key53 < _len53; _key53++) {
        args[_key53 - 2] = arguments[_key53];
      }

      return (_this$client28 = this.client).post.apply(_this$client28, ["/b2b-sow/team/".concat(sowGroupId, "/excluded-coaches"), reqData].concat(args));
    }
  }, {
    key: "addSOWGroupCoaches",
    value: function addSOWGroupCoaches(sowGroupId, data) {
      var _this$client29;

      for (var _len54 = arguments.length, args = new Array(_len54 > 2 ? _len54 - 2 : 0), _key54 = 2; _key54 < _len54; _key54++) {
        args[_key54 - 2] = arguments[_key54];
      }

      return (_this$client29 = this.client).post.apply(_this$client29, ["/b2b-sow/team/".concat(sowGroupId, "/add-coaches"), data].concat(args));
    }
  }, {
    key: "removeSOWGroupCoaches",
    value: function removeSOWGroupCoaches(sowGroupId, data) {
      var _this$client30;

      for (var _len55 = arguments.length, args = new Array(_len55 > 2 ? _len55 - 2 : 0), _key55 = 2; _key55 < _len55; _key55++) {
        args[_key55 - 2] = arguments[_key55];
      }

      return (_this$client30 = this.client).post.apply(_this$client30, ["/b2b-sow/team/".concat(sowGroupId, "/remove-coaches"), data].concat(args));
    }
  }, {
    key: "updateCoachCustomPricing",
    value: function updateCoachCustomPricing(sowGroupId, coachId, data) {
      var _this$client31;

      for (var _len56 = arguments.length, args = new Array(_len56 > 3 ? _len56 - 3 : 0), _key56 = 3; _key56 < _len56; _key56++) {
        args[_key56 - 3] = arguments[_key56];
      }

      return (_this$client31 = this.client).put.apply(_this$client31, ["/b2b-sow/team/".concat(sowGroupId, "/coach/").concat(coachId, "/pricing"), data].concat(args));
    }
  }, {
    key: "addCoach",
    value: function addCoach(orgEcoId, data) {
      var _this$client32;

      for (var _len57 = arguments.length, args = new Array(_len57 > 2 ? _len57 - 2 : 0), _key57 = 2; _key57 < _len57; _key57++) {
        args[_key57 - 2] = arguments[_key57];
      }

      return (_this$client32 = this.client).put.apply(_this$client32, ["/company/".concat(orgEcoId, "/assign-coach"), data].concat(args));
    }
  }]);
  return CompanyList;
}(_survey["default"]);

exports["default"] = CompanyList;